import { render, staticRenderFns } from "./ReferralForm.vue?vue&type=template&id=8f6b9104&scoped=true&"
import script from "./ReferralForm.vue?vue&type=script&lang=js&"
export * from "./ReferralForm.vue?vue&type=script&lang=js&"
import style0 from "./ReferralForm.vue?vue&type=style&index=0&id=8f6b9104&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f6b9104",
  null
  
)

export default component.exports